import React from "react";
import PropTypes from "prop-types";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

import useDialogStyle from "./hooks";

const EXIT_MESSAGE =
  "Leaving Work Desk will end your current Work Session. " +
  "You can start a new Work Session at any time to generate a new prioritized queue.";

function WorkDeskExitConfirmationDialog({ open, onStay, onExit }) {
  const classes = useDialogStyle();

  return (
    <Dialog
      open={open}
      onClose={onStay}
      data-test="work-session-exit-confirm"
      PaperProps={{ className: classes.paper }}
    >
      <DialogTitle disableTypography className={classes.title}>
        Exit Work Session?
      </DialogTitle>
      <DialogContent className={classes.content}>
        <DialogContentText className={classes.body}>
          {EXIT_MESSAGE}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          variant="contained"
          disableElevation
          className={`${classes.button} ${classes.stayButton}`}
          onClick={onStay}
        >
          Stay in Session
        </Button>
        <Button
          variant="contained"
          disableElevation
          className={`${classes.button} ${classes.exitButton}`}
          onClick={onExit}
        >
          Exit Session
        </Button>
      </DialogActions>
    </Dialog>
  );
}

WorkDeskExitConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onStay: PropTypes.func.isRequired,
  onExit: PropTypes.func.isRequired,
};

export default WorkDeskExitConfirmationDialog;
